var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNuvebFinal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080,
    fill: "#00040F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.332 631H239.872L165.512 518.42V631H121.052V448.48H165.512L239.872 561.58V448.48H284.332V631ZM459.819 485.92V631H415.359V611.24C410.853 617.653 404.699 622.853 396.899 626.84C389.273 630.653 380.779 632.56 371.419 632.56C360.326 632.56 350.533 630.133 342.039 625.28C333.546 620.253 326.959 613.06 322.279 603.7C317.599 594.34 315.259 583.333 315.259 570.68V485.92H359.459V564.7C359.459 574.407 361.973 581.947 366.999 587.32C372.026 592.693 378.786 595.38 387.279 595.38C395.946 595.38 402.793 592.693 407.819 587.32C412.846 581.947 415.359 574.407 415.359 564.7V485.92H459.819Z",
    fill: "url(#paint0_radial_586_1181)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M557.015 589.4L588.475 485.92H635.795L584.315 631H529.455L477.975 485.92H525.555L557.015 589.4ZM791.269 556.12C791.269 560.28 791.009 564.613 790.489 569.12H689.869C690.562 578.133 693.422 585.067 698.449 589.92C703.649 594.6 709.975 596.94 717.429 596.94C728.522 596.94 736.235 592.26 740.569 582.9H787.889C785.462 592.433 781.042 601.013 774.629 608.64C768.389 616.267 760.502 622.247 750.969 626.58C741.435 630.913 730.775 633.08 718.989 633.08C704.775 633.08 692.122 630.047 681.029 623.98C669.935 617.913 661.269 609.247 655.029 597.98C648.789 586.713 645.669 573.54 645.669 558.46C645.669 543.38 648.702 530.207 654.769 518.94C661.009 507.673 669.675 499.007 680.769 492.94C691.862 486.873 704.602 483.84 718.989 483.84C733.029 483.84 745.509 486.787 756.429 492.68C767.349 498.573 775.842 506.98 781.909 517.9C788.149 528.82 791.269 541.56 791.269 556.12ZM745.769 544.42C745.769 536.793 743.169 530.727 737.969 526.22C732.769 521.713 726.269 519.46 718.469 519.46C711.015 519.46 704.689 521.627 699.489 525.96C694.462 530.293 691.342 536.447 690.129 544.42H745.769ZM859.184 506.46C863.344 499.7 869.324 494.24 877.124 490.08C884.924 485.92 893.85 483.84 903.904 483.84C915.864 483.84 926.697 486.873 936.404 492.94C946.11 499.007 953.737 507.673 959.284 518.94C965.004 530.207 967.864 543.293 967.864 558.2C967.864 573.107 965.004 586.28 959.284 597.72C953.737 608.987 946.11 617.74 936.404 623.98C926.697 630.047 915.864 633.08 903.904 633.08C893.677 633.08 884.75 631.087 877.124 627.1C869.497 622.94 863.517 617.48 859.184 610.72V631H814.724V438.6H859.184V506.46ZM922.624 558.2C922.624 547.107 919.504 538.44 913.264 532.2C907.197 525.787 899.657 522.58 890.644 522.58C881.804 522.58 874.264 525.787 868.024 532.2C861.957 538.613 858.924 547.367 858.924 558.46C858.924 569.553 861.957 578.307 868.024 584.72C874.264 591.133 881.804 594.34 890.644 594.34C899.484 594.34 907.024 591.133 913.264 584.72C919.504 578.133 922.624 569.293 922.624 558.2Z",
    fill: "url(#paint1_radial_586_1181)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_586_1181",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(501.25 460.8) rotate(133.106) scale(340.233 2998.33)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#BDB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#AAA3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#887EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7267FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5547FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_586_1181",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(427 810) rotate(-38.8328) scale(724.025 4785.85)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#AAF1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "#9FF1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#6AE3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#54DEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985848,
    stopColor: "#33BBCF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuvebFinal);
export default __webpack_public_path__ + "static/media/NuvebFinal.29eae4cd2b9df2ea0e04706d92330176.svg";
export { ForwardRef as ReactComponent };